"use client";
import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Icon from "@/assets/images/blog/twitter.svg";
import Icon2 from "@/assets/images/blog/facebook.svg";
import Icon3 from "@/assets/images/blog/linkedin.svg";
import Icon4 from "@/assets/images/blog/whatsapp.svg";
import Icon5 from "@/assets/images/blog/link.svg";

interface SocialMediaProps {
  title: string;
  slug: string;
  host: string;
}

const SocialMedia: React.FC<SocialMediaProps> = ({ title, slug, host }) => {
  const [copylink, setCopylink] = useState(false);

  const handleCopy = () => {
    setCopylink((prev) => !prev);
  };

  const linkCopiedHandler = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopylink(true);
    setTimeout(() => setCopylink(false), 2000);
  };

  return (
    <div className="flex min-h-[50px] items-start justify-start gap-5">
      <Link
        className="icon-details-hover flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md transition-shadow hover:shadow-lg"
        href={`https://twitter.com/intent/tweet?via=kroolo_blog&text=${title}&url=${host}/blog/${slug}`}
        target="_blank"
      >
        <button>
          <Image
            className="cursor-pointer"
            src={Icon}
            alt="Share on X (Twitter)"
            width={21}
            height={21}
          />
        </button>
      </Link>
      <Link
        className="icon-details-hover flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md transition-shadow hover:shadow-lg"
        href={`https://www.facebook.com/sharer/sharer.php?u=${host}/blog/${slug}`}
        target="_blank"
      >
        <button>
          <Image
            className="cursor-pointer"
            src={Icon2}
            alt="Share on Facebook"
            width={24}
            height={24}
          />
        </button>
      </Link>
      <Link
        className="icon-details-hover flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md transition-shadow hover:shadow-lg"
        href={`http://www.linkedin.com/shareArticle?mini=true&title=${title}&url=${host}/blog/${slug}`}
        target="_blank"
      >
        <button>
          <Image
            className="cursor-pointer"
            src={Icon3}
            alt="Share on LinkedIn"
            width={22}
            height={22}
          />
        </button>
      </Link>

      <button
        style={{ border: "none", background: "transparent" }}
        onClick={() =>
          window.open(
            `${
              host ? "whatsapp:/" : "https://web.whatsapp.com"
            }/send?text=Click on below link to read more about ${title}%0a${host}/blog/${slug}`,
          )
        }
      >
        <div className="icon-details-hover flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md transition-shadow hover:shadow-lg">
          <Image
            className="cursor-pointer"
            src={Icon4}
            alt="Share on WhatsApp"
            width={22}
            height={22}
          />
        </div>
      </button>
      <button style={{ border: "none", background: "transparent" }}>
        <div className="icon-details-hover relative flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-white shadow-md transition-shadow hover:shadow-lg">
          <Image
            className="cursor-pointer"
            src={Icon5}
            alt="Copy share link"
            onClick={linkCopiedHandler}
            width={22}
            height={22}
          />
        </div>
      </button>
      {copylink && (
        <div className="absolute -top-8 left-1/2 -translate-x-1/2 transform rounded bg-gray-800 px-2 py-1 text-xs text-white">
          Link copied!
        </div>
      )}
    </div>
  );
};

export default SocialMedia;
